import TabDropdown from './TabDropdown';
import TabCloseIcon from './TabCloseIcon';
import TabMemuClose from './TabMemuClose';
import MulticolumnSettingIcon from './MulticolumnSettingIcon';
import BannerSettingIcon from './BannerSettingIcon';
import NicknameSettingIcon from './NicknameSettingIcon';
import Comment3 from './Comment3';
import ActivityBtn from './ActivityBtn';
import PriceList from './PriceList';
import Product from './Product';
import Signature from './Signature';
import Template from './Template';
import MarketPage from './MarketPage';
import Mannual from './Mannual';
export default {
    TabDropdown,
    TabCloseIcon,
    TabMemuClose,
    MulticolumnSettingIcon,
    BannerSettingIcon,
    NicknameSettingIcon,
    Comment3,
    ActivityBtn,
    PriceList,
    Product,
    Signature,
    Template,
    MarketPage,
    Mannual,
};
